import { Card, useTheme } from '@mui/material'
import React from 'react'
import TableCard from '../../../../Components/TableCard'
function TabCard({ oldData }) {
  const theme = useTheme()
  return (
    <Card
      style={{
        backgroundColor: theme.palette.appBar.main,
        padding: '15px',
        boxShadow: 'none',
        overflowY: 'revert',
        scrollbarWidth: 'thin',
      }}
    >
      <TableCard data={oldData} />
    </Card>
  )
}

export default TabCard
